import { RatingKeys, RatingRanges } from '@globalTypes/index';
import cloneDeep from 'lodash.clonedeep';

/**
 * Finds the range key for a given value in the rating ranges object.
 *
 * @function
 * @param {number} value - The value for which the range key needs to be found.
 * @param {RatingRanges} originalRanges - The original rating ranges object.
 * @returns {RatingKeys} - The range key corresponding to the given value in the rating ranges.
 */
export const findRangeKey = (value: number, originalRanges: RatingRanges): RatingKeys => {
  const ranges: RatingRanges = cloneDeep(originalRanges);
  ranges.A[0] = -Infinity;
  ranges.E[1] = Infinity;
  return (Object.entries(ranges).find(([_, [start, end]]) => value >= start && value < end) ?? [])[0] as RatingKeys;
};
